import { createContext } from 'react'
import { FieldState } from './formReducer'
import React from 'react'

type FieldContextType = {
    fieldState: FieldState
    fieldDispatch: any
    // TODO add type here
}
const FieldContext = createContext<FieldContextType>({
    fieldState: { fieldInstances: [] },
    fieldDispatch: () => {},
})

export function useFieldContext() {
    return React.useContext(FieldContext)
}

export default FieldContext
